import React from "react";
import PropTypes from "prop-types";

import { Button } from "../../../../components/simple";

import SVG from "../../../../components/SVG";

import styles from "./header.module.scss";

const Header = ({
  onGoBack,
  params: { type },
  setIsSelectClientModalOpen,
  isAudienceActive
}) => {
  return (
    <div className={styles["header-wrapper"]}>
      <div className={styles["header-title"]}>
        {type === "audience" && (
          <>
            <Button className="btn-transparent close-modal" onClick={onGoBack}>
              <SVG.Arrow
                className={styles["header-arrow"]}
                width={18}
                height={13}
              />
            </Button>
            <h1 className="title">Full Report</h1>
          </>
        )}
      </div>
      <div className={styles["header-buttons"]}>
        {isAudienceActive ? (
          <Button
            // onClick={handlePushButtonClick}
            onClick={setIsSelectClientModalOpen}
            className={`button ${styles["button-activate"]}`}
          >
            <span>Activate</span>
          </Button>
        ) : null}
      </div>
    </div>
  );
};

Header.propTypes = {
  user: PropTypes.shape({}).isRequired,
  companyPlan: PropTypes.shape({
    limitedFunctionality: PropTypes.bool.isRequired
  }).isRequired,
  data: PropTypes.shape({}).isRequired,
  onGoBack: PropTypes.func.isRequired,
  params: PropTypes.shape({
    id: PropTypes.string.isRequired,
    threshold: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired,
  setIsSelectClientModalOpen: PropTypes.func.isRequired,
  isAudienceActive: PropTypes.bool
};

Header.defaultProps = {
  isAudienceActive: true
};

export default Header;
